
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Notifications_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 33.16 41.97","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Notifications_svg__st0",attrs:{"d":"M15.83 4.91c-2.49.26-4.59 1.8-5.48 4.02-.84 2.08-.47 4.37 1 6.12 1.12 1.32 1.78 3.73 1.83 5.31.01.37.34.67.74.67h5.31c.4 0 .73-.29.74-.67.06-1.87.84-4.08 1.89-5.38l.02-.02c1.57-1.92 1.81-4.46.64-6.64-1.29-2.39-3.85-3.7-6.69-3.41zm4.87 9.2c-1.11 1.35-1.94 3.45-2.16 5.46l-.01.07h-1.21v-5.48l.02-.02L19 12.58l-1.04-.98-1.38 1.3-.05-.05-1.34-1.27-1.05.98 1.69 1.6v5.48H14.6l-.01-.07c-.18-1.56-.83-3.9-2.09-5.39-1.14-1.36-1.43-3.14-.78-4.77.7-1.73 2.33-2.93 4.26-3.13 2.2-.22 4.19.78 5.19 2.63.94 1.72.75 3.71-.47 5.2zM10.92 35.17h11.32v1H10.92zM10.92 38.07h11.32v1H10.92zM10.92 40.97h11.32v1H10.92z"}}),_c('path',{staticClass:"Notifications_svg__st0",attrs:{"d":"M29.43 0H3.73C1.67 0 0 1.63 0 3.64v18.11c0 2.01 1.67 3.64 3.73 3.64h5.76l7.09 8.38 7.09-8.38h5.76c2.06 0 3.73-1.63 3.73-3.64V3.64c0-2.01-1.67-3.64-3.73-3.64zm2.13 21.75c0 1.12-.96 2.04-2.13 2.04h-6.5l-6.35 7.51-6.35-7.51h-6.5c-1.17 0-2.13-.91-2.13-2.04V3.64c0-1.12.96-2.04 2.13-2.04h25.7c1.17 0 2.13.91 2.13 2.04v18.11z"}})])
          )
        }
      }
    